import { Icon, Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

type Props = {
	text: string;
	showClockIcon?: boolean;
};

const ProgressText = ({ text, showClockIcon = false }: Props) => {
	const theme = useAppTheme();
	const label = (
		<Text
			variant="labelMedium"
			numberOfLines={1}
			style={{
				color: theme.colors.onSurface,
				textAlign: "right",
				fontWeight: "500",
				flexShrink: 0,
			}}
		>
			{text}
		</Text>
	);

	if (!showClockIcon) {
		return label;
	}

	return (
		<Box flexDirection="row" alignItems="center" gap={4} flexShrink={0}>
			<Icon
				source="clock-outline"
				size={16}
				color={theme.colors.onSurfaceVariant}
			/>
			{label}
		</Box>
	);
};

export default ProgressText;
